import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/OrdenProduccion/ordenproduccion';
import ColaDeProduccion from './colaProduccion';

const mstp = state => {
    return {...state.produccion, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ColaDeProduccion)